/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * Categorieservice.ts
 */

import KareviAPIService from "../tools/service/KareviAPIService";
import Category from "../models/Category";
import QueryFilter from "../tools/model/pagination/Filters";
import {Listener} from "../tools/service/Service";
import {Selectable} from "../tools/model/form/Selectable";
import {PaginationFilters} from "../tools/pagination/PaginationFilters";

export default class CategoryService extends KareviAPIService<Category, Listener<Category>> {
    public static SINGLE_ROUTE = '/category/{categoryId}';
    public static LIST_ROUTE = '/categories';
    public static id = "CategoryService";

    public static convertToSelectable(categories: Array<Category>): Array<Selectable<Category>> {
        let result: Array<Selectable<Category>> = [];

        for (let category of categories) {
            result.push({
                value: category,
                name: category.title,
                disabled: false
            })
        }

        return result;
    }

    /**
     * start
     */
    public start() {
        super.start();
    }

    /**
     * stop
     */
    public stop() {
        super.stop();
    }

    /**
     * createCategory
     * @return {Promise<Category>}
     * @param dto
     */
    public async createCategory(dto: Map<string, any> | FormData): Promise<Category> {
        return await this.post(CategoryService.LIST_ROUTE, dto);
    }

    /**
     * updateCategory
     * @return {Promise<Category>}
     * @param dto
     * @param category
     */
    public async updateCategory(category: Category, dto: Map<string, any> | FormData): Promise<Category> {
        const route = this.httpService.buildRoute(CategoryService.SINGLE_ROUTE, {
            categoryId: category.id
        });

        return await this.put(route, dto);
    }

    /**
     * findById
     * @returns {Promise<void>}
     */
    public async findById(id: string): Promise<Category> {
        const route = this.httpService.buildRoute(CategoryService.SINGLE_ROUTE, {
            categoryId: id
        });

        return await this.getOne<Category>(route);
    }

    /**
     * findAll
     * @returns {Promise<Category[]>}
     */
    public async findAll(): Promise<Category[]> {
        const categoryFilters: QueryFilter<PaginationFilters> = new QueryFilter<PaginationFilters>({
            page: 0,
            size: 10000
        });

        return await this.getList<Category, PaginationFilters>(CategoryService.LIST_ROUTE, categoryFilters);
    }
}
